import config from '../config';
import { handleResponse, addTenant } from './helpers';

export const surveyService = {
    getSurvey,
    createSurveyResponse,
    createSurvey,
    updateSurvey
};

function getSurvey(code) {
    const requestOptions = { 
        method: 'GET', 
        headers: { 'Content-Type': 'application/json', ...addTenant() },
    };

    return fetch(`${config.apiUrl}/surveys?code=${code}`, requestOptions).then(handleResponse).then((data) => {
        return data;
    });
}

function createSurvey(data) {
    console.log("Create survey:", data)
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...addTenant() },
        body: JSON.stringify(data)
    };

    return fetch(`${config.apiUrl}/surveys`, requestOptions)
        .then(handleResponse)
        .then((data) => {
            return data;
        });
}

function updateSurvey(data) {
    console.log("Update survey:", data)
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...addTenant() },
        body: JSON.stringify(data)
    };

    return fetch(`${config.apiUrl}/surveys`, requestOptions)
        .then(handleResponse)
        .then((data) => {
            return data;
        });
}


function createSurveyResponse(data) {
    console.log("Create survey response:", data)
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...addTenant() },
        body: JSON.stringify(data)
    };

    return fetch(`${config.apiUrl}/surveys/responses`, requestOptions)
        .then(handleResponse)
        .then((data) => {
            return data;
        });
}
